import { useAlertStore } from './alertStore'

export const useAlert = () => {
  const type = useAlertStore((state) => state.type)
  const message = useAlertStore((state) => state.message)
  const show = useAlertStore((state) => state.show)
  const id = useAlertStore((state) => state.id)
  const showAlert = useAlertStore((state) => state.showAlert)

  return {
    alert: {
      type,
      message,
      show,
      id,
    },
    showAlert,
  }
}
